module.exports = __webpack_public_path__ + "img/commander2.png";